module.exports = __webpack_public_path__ + "img/simple.662f64a0.png";